<template>
    <div class="page-container page-container--height chat-visible teacher-cabinet" :class="{'is-active' : state, 'sidebar-collapsed--chat' : sidebarStateRight, 'sidebar-collapsed' : sidebarStateLeft} ">
        <app-left-panel></app-left-panel>
        <a href="javascript:void(0);" class="close-sidebar"  @click.prevent="appp" :class="{'is-active' : state}">
            <img :src="env.public_base + '/assets/images/arrow-left-icon.svg'" alt="">
        </a>
        <div class="main-content container" :class="{'is-active' : state}">

            <div class="chat-head">
                <div class="chat-head__lesson">

                    <div class="lesson__bg lesson__bg--dashboard">
                        <img :src="env.public_base + '/assets/images/home-icon.svg'" alt="" width="30px">
                    </div>
                    <p class="messages__text messages__text--empty">{{$t('home')}}</p>

                </div>
                <button type="button" class="btn btn-blue btn-icon icon-left" :class="{'is-active' : state}">
                    Чат
                    <i class="">
                        <img :src="env.public_base + '/assets/images/chats-icon.svg'" alt="">
                    </i>
                </button>


            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="tabs-container">
                        <button type="button" class="btn btn-link is-active"><span>{{$t('all')}}</span></button>
                        <button type="button" class="btn btn-link"><span>{{$t('need_to_check')}}</span></button>
                        <button type="button" class="btn btn-link"><span>{{$t('optional')}}</span></button>
                    </div>

                    <div class="teacher-list">
                        <div class="row">
                            <div class="col-lg-6" v-for="item in 15">
                                <a href="javascript:void(0);" class="list-item">
                                    <div class="list-item_img">
                                        <!--                                        <img src="http://dev-chat.ukel.com.ua/static/front-end/public/assets/images/person-icon.png" alt="">-->
                                    </div>
                                    <div class="list-item_descr">
                                        <div class="list-item_descr-type">Курс</div>
                                        <div class="list-item_descr-name">
                                            Math
                                        </div>
                                        <div class="list-item_descr-progress">
                                            <div class="progress">
                                                <div class="progress-bar progress-bar-success" role="progressbar"
                                                     aria-valuenow="35" aria-valuemin="0" aria-valuemax="100"
                                                     style="width: 35%"><span class="sr-only">35% Complete (success)</span>
                                                </div>
                                            </div>
                                            <span>35%</span>
                                        </div>
                                        <div class="list-item_descr-message">
                                            Need to check:
                                            <span>7</span>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div id="chat" class="right-sidebar" v-if="state" :class="{'is-active' : state}">
            <div class="sidebar_top">
                <div class="sidebar_top-header">
                    <img :src="env.public_base + '/assets/images/schedule-icon.svg'" alt="">
                    <span>
                        {{$t('schedule_of_consultations')}}
                    </span>
                    <a href="javascript:void(0);" @click.prevent="appp2">
                        <img :src="env.public_base + '/assets/images/close-icon.svg'" alt="">
                    </a>
                </div>
                <div class="sidebar_top-body">
                    <div class="schedule-title">
                        tuesday, 25 may 2019
                    </div>
                    <div class="schedule-list">
                        <a href="javascript:void(0);">3rd class - 14:30-15:30</a>
                        <a href="javascript:void(0);">4th class - 15:30-16:30</a>
                    </div>
                </div>
            </div>

            <div class="sidebar_check">
                <div class="check-title">
                    <img :src="env.public_base + '/assets/images/warning-icon.svg'" alt="">
                    <span>{{$t('need_to_check')}}</span>
                </div>
                <div class="check-body">
                    <a href="javascript:void(0);">
                        Math 3
                        <span>7</span>
                    </a>
                    <a href="javascript:void(0);">
                        Math 4
                        <span>13</span>
                    </a>
                </div>
            </div>
            <!-- <app-languages></app-languages> -->
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import LeftPanel from '../LeftPanel.vue';
    import RightPanel from '../RightPanel.vue';
    import ProfileForm from '../../../common_components/ProfileForm.vue';
    import env from '../../../env'
    // import Languages from '../Languages';


    export default {
        data: function () {
            return {
                env,
                state: true
            }
        },
        created(){

        },
        methods: {
            appp() {
                this.state = !this.state;
            },
            appp2(){
                this.state = false;
            }
        },
        computed: {
            ...mapGetters(['teacher', 'sidebarStateLeft',
                'sidebarStateRight',])
        },
        components: {
            appLeftPanel: LeftPanel,
            appRightPanel: RightPanel,
            appProfileForm: ProfileForm,
            // appLanguages: Languages,
        },

    }
</script>

<style scoped lang="sass">
    @import "../../../../sass/cabinet"
    @import "../../../../sass/teacherLesson"
    @import "../../../../sass/teacherCheckwork"
    @import "../../../../sass/studentStat"
    @import "../../../../sass/teacherMaterials"
    @import "../../../../sass/rightPanel"
</style>
